import React, { useEffect } from 'react';
import html from './TermsAndConditionsContents';

const TermsAndConditions = (): JSX.Element => {
  useEffect(() => {
    document.title = 'Terms & Conditions';
  }, []);
  // HTML file was provided by PreSci, so we are hosting it here
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default TermsAndConditions;
